module.exports = __webpack_public_path__ + "img/7.23753c24.png";